import { useQuery } from '@tanstack/react-query';

import type { TTalentUser } from '@/shared/contexts/TalentAuth/hooks/useGetUserData';

import { fetcher } from '../utils/fetcher';

const ENDPOINT = process.env.TALENT_API_INTEGRATION;

export const useLearningToken = ({ user }: { user: TTalentUser | null }) => {
  const { data, isError, error, isPending } = useQuery({
    queryKey: ['learning-jwt', user?.employee_id],
    queryFn: () =>
      fetcher<{ token: string }>(
        `${ENDPOINT}/learningintegration/security/generate-token`,
        {
          method: 'POST',
          body: JSON.stringify(user?.employee_id),
          skipAuth: true,
        },
      ),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(user),
  });

  if (isError) {
    console.error(error);
  }

  const token = typeof data === 'object' ? data.token : undefined;

  // all queries dispatched will have these headers since this
  // window.crehApolloHeaders variable is assigned will has the `x-talent-authorization` header
  if (token && typeof window !== 'undefined') {
    window.crehApolloHeaders = {
      ...window.crehApolloHeaders,
      'x-talent-authorization': token,
    };
  }

  return {
    token,
    isPending,
  };
};
